import { MdLocalShipping, MdPlace } from 'react-icons/md';
import { ReturnConsignment as ReturnConsignmentType } from 'types';
import { Heading, Text, useDrawer } from 'components';
import { formatTimestamp } from 'helpers';
import { FontSize, FontWeight, RETURN_STATUSES } from 'commons';
import * as S from './styles';

const POST_OFFICE = 'POST_OFFICE';

interface Props {
  action?: () => void;
  isSelected: boolean;
  consignment: ReturnConsignmentType;
}

export function ReturnConsignment({ action, isSelected, consignment }: Props) {
  const { setIsOpen } = useDrawer();

  const {
    consignmentCode,
    customerCpf,
    returnRequestStatus,
    customerName,
    createdDate,
    protocol,
    optionsCollect,
  } = consignment;
  const { hour, minute, day, month } = formatTimestamp(createdDate);

  const isPostOffice = optionsCollect === POST_OFFICE;
  const returnOptionText = isPostOffice
    ? 'Postado nos correios'
    : 'Devolvido na Loja';
  const returnOptionIcon = isPostOffice ? <MdLocalShipping /> : <MdPlace />;

  function handleAction() {
    setIsOpen(true);
    if (!action) return;
    action();
  }

  return (
    <S.Button onClick={handleAction} $selected={isSelected}>
      <S.Section>
        <S.TextWrapper>
          <S.TextOverflowContainer>
            <Heading
              as="h3"
              size={FontSize.font14}
              weight={FontWeight.bold}
              className="text-overflow"
            >
              {customerName}
            </Heading>
          </S.TextOverflowContainer>

          <Text className="nowrap">
            Protocolo: <b>{protocol}</b>
          </Text>
        </S.TextWrapper>

        <S.TextWrapper>
          <Text size={FontSize.font12}>{customerCpf}</Text>

          <Text size={FontSize.font12} className="nowrap">
            Pedido: <b>{consignmentCode}</b>
          </Text>
        </S.TextWrapper>
      </S.Section>

      <S.Division />

      <S.Section $alignEnd>
        <S.TextWrapper>
          <Text size={FontSize.font12} className="text-end">
            Devolução solicitada em {day}/{month} ás {hour}h{minute}
          </Text>
        </S.TextWrapper>

        <S.TextWrapper>
          <S.ReturnStatus $status={returnRequestStatus}>
            {RETURN_STATUSES[returnRequestStatus]?.label ||
              'Status desconhecido'}
          </S.ReturnStatus>

          <S.ReturnOptionWrapper>
            <S.ReturnOptionIcon>{returnOptionIcon}</S.ReturnOptionIcon>

            <Text size={FontSize.font12}>{returnOptionText}</Text>
          </S.ReturnOptionWrapper>
        </S.TextWrapper>
      </S.Section>
    </S.Button>
  );
}
